import { GetMenuAppMetadataResponse } from "api-types";
import { AxiosInstance } from "axios";

import { UseQueryResult, useQuery } from "react-query";

import { getMenuAppMetadata } from "../menus-client";

export const useMenuAppMetadataQuery = (
  client: AxiosInstance,
  igfdTaxIngredientIds?: string[]
): UseQueryResult<GetMenuAppMetadataResponse> => {
  const qKey = ["menuAppMetadata", ...(igfdTaxIngredientIds ?? [])];

  return useQuery(qKey, () => getMenuAppMetadata(client, igfdTaxIngredientIds));
};
